import { useConfig as z, useStripeConfig as fe, useBillingAddress as ot, useBookingForm as Z, useSelectedTimeSlot as ge, useDateFormatters as le, useLocations as _e, useReservationReschedule as ve, book as pt, reschedule as ht, reserve as ft, confirm as vt, cancel as xt, useCalendar as K, useCurrentTimezone as bt, useHourCycle as gt, mergeObjects as _t, fetchRemoteConfiguration as kt } from "@zaptime/core";
import { book as _o, cancel as ko, confirm as yo, reserve as wo } from "@zaptime/core";
import { ref as T, computed as D, defineComponent as S, openBlock as n, createElementBlock as d, normalizeClass as V, renderSlot as me, createElementVNode as c, mergeModels as pe, useModel as ke, toDisplayString as x, withDirectives as re, vModelDynamic as yt, Fragment as E, renderList as N, vModelSelect as nt, onMounted as ye, createBlock as J, inject as b, watch as ae, Teleport as wt, resolveDynamicComponent as Ct, unref as e, createCommentVNode as _, createVNode as v, Transition as we, withCtx as L, pushScopeId as $t, popScopeId as Vt, normalizeProps as ee, guardReactiveProps as te, normalizeStyle as se, withModifiers as Q, createTextVNode as O, vShow as st, createStaticVNode as St, nextTick as It, useCssVars as Mt, provide as xe } from "vue";
import Tt from "analytics";
import Ft from "@analytics/google-analytics";
import Bt from "load-script";
import { onClickOutside as Lt, useDebounceFn as Ht, useBreakpoints as rt } from "@vueuse/core";
import { Combobox as zt, ComboboxInput as jt, ComboboxButton as Dt, TransitionRoot as At, ComboboxOptions as Pt, ComboboxOption as Et, SwitchGroup as Ut, SwitchLabel as Xe, Switch as Nt } from "@headlessui/vue";
import { isSameDay as qt } from "date-fns";
const U = T({
  __DEFAULT__: {
    view: "calendar",
    calendarView: "pickingDate"
  }
});
function Ce(s) {
  s !== void 0 && U.value[s] === void 0 && (U.value[s] = {
    view: "calendar",
    calendarView: "pickingDate"
  });
  const a = D(() => s === void 0 ? U.value.__DEFAULT__.view : U.value[s].view), o = D(() => s === void 0 ? U.value.__DEFAULT__.calendarView : U.value[s].calendarView);
  return {
    view: a,
    calendarView: o,
    setView: (i) => {
      s === void 0 ? U.value.__DEFAULT__.view = i : U.value[s].view = i;
    },
    setCalendarView: (i) => {
      s === void 0 ? U.value.__DEFAULT__.calendarView = i : U.value[s] === void 0 ? U.value[s] = {
        calendarView: i,
        view: a.value
      } : U.value[s].calendarView = i;
    }
  };
}
const Zt = ["disabled"], Rt = /* @__PURE__ */ c("circle", {
  class: "cal-opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1), Ot = /* @__PURE__ */ c("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1), Gt = [
  Rt,
  Ot
], he = /* @__PURE__ */ S({
  __name: "PrimaryButton",
  props: {
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["click"],
  setup(s) {
    return (a, o) => (n(), d("button", {
      disabled: a.disabled || a.loading,
      class: "cal-inline-flex cal-items-center cal-rounded-md cal-bg-accent-base cal-px-4 cal-py-3 cal-font-medium cal-text-white cal-transition-all cal-duration-75 cal-ease-out hover:cal-bg-accent-dark disabled:cal-cursor-not-allowed disabled:cal-opacity-80 disabled:hover:cal-bg-accent-base dark:cal-bg-accent-base dark:cal-text-theme-900 hover:dark:cal-bg-accent-dark hover:dark:cal-text-theme-900 sm:cal-px-6 sm:cal-py-3.5",
      onClick: o[0] || (o[0] = (l) => a.$emit("click"))
    }, [
      (n(), d("svg", {
        class: V(["cal-mr-3 cal-h-5 cal-w-5 cal-animate-spin cal-text-white cal-ease-in", [a.loading ? "cal-inline-block" : "cal-hidden"]]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, Gt, 2)),
      me(a.$slots, "default")
    ], 8, Zt));
  }
}), $e = (s, a) => {
  const o = s.__vccOpts || s;
  for (const [l, t] of a)
    o[l] = t;
  return o;
}, Wt = {};
function Jt(s, a) {
  return n(), d("button", {
    class: "cal-mr-2 cal-rounded-md cal-bg-theme-100 cal-px-4 cal-py-2 cal-font-medium cal-text-accent-base cal-transition-all cal-duration-75 cal-ease-out hover:cal-bg-theme-200 hover:cal-text-accent-dark dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-text-white hover:dark:cal-bg-theme-700 hover:dark:cal-text-accent-base sm:cal-px-6 sm:cal-py-3.5",
    onClick: a[0] || (a[0] = (o) => s.$emit("click"))
  }, [
    me(s.$slots, "default")
  ]);
}
const Ye = /* @__PURE__ */ $e(Wt, [["render", Jt]]);
let ie, be = !1;
function Xt(s) {
  return {
    name: "facebook-pixel",
    initialize: async () => {
      const { pixelId: a } = s;
      typeof window < "u" && await import("react-facebook-pixel").then((o) => ie = o.default).then(() => {
        be || (ie.init(a, {
          autoConfig: !0,
          debug: !0
        }), be = !0);
      });
    },
    page: () => {
      ie.pageView();
    },
    track: ({ payload: a }) => {
      ie.track(a.event, a.properties);
    },
    loaded: () => be
  };
}
let Qe = !1;
function Yt(s) {
  return {
    name: "umami",
    initialize: async () => {
      const { src: a, dataWebsiteId: o } = s;
      typeof window < "u" && Bt(
        a,
        {
          attrs: {
            "data-website-id": o
          }
        },
        (l) => {
          l ? console.log(l) : Qe = !0;
        }
      );
    },
    page: () => {
      "umami" in window && window.umami.track();
    },
    track: ({ payload: a }) => {
      "umami" in window && window.umami.track(a.event, a.properties);
    },
    loaded: () => Qe
  };
}
let de;
function Ve(s) {
  if (!(typeof window > "u") && !(s === void 0 && de === void 0))
    return de === void 0 && (de = Tt(s)), de;
}
function Qt(s) {
  const a = [];
  for (const l of s)
    switch (l.name) {
      case "google-analytics":
        a.push(
          Ft({
            measurementIds: [l.data.measurementId],
            enabled: !0
          })
        );
        break;
      case "facebook-pixel":
        a.push(
          Xt({
            pixelId: l.data.pixelId,
            enabled: !0
          })
        );
        break;
      case "umami":
        a.push(
          Yt({
            dataWebsiteId: l.data.dataWebsiteId,
            src: l.data.src,
            enabled: !0
          })
        );
        break;
      default:
        throw new Error(`Unknown Analytics Plugin Option: ${name}`);
    }
  return {
    app: "Zaptime",
    debug: !0,
    plugins: a
  };
}
const Kt = ["for"], ea = { class: "cal-mt-2" }, ta = ["required", "type", "name", "autocomplete", "placeholder"], W = /* @__PURE__ */ S({
  __name: "TextInput",
  props: /* @__PURE__ */ pe({
    label: {},
    required: { type: Boolean, default: !1 },
    type: {},
    name: {},
    autocomplete: {},
    placeholder: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ pe(["update:modelValue", "blur"], ["update:modelValue"]),
  setup(s, { emit: a }) {
    const o = a, l = ke(s, "modelValue");
    return (t, i) => (n(), d("div", null, [
      c("label", {
        for: t.name,
        class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200"
      }, x(t.label), 9, Kt),
      c("div", ea, [
        re(c("input", {
          "onUpdate:modelValue": i[0] || (i[0] = (r) => l.value = r),
          required: t.required,
          type: t.type,
          name: t.name,
          autocomplete: t.autocomplete,
          class: "cal-block cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-3.5 cal-text-base cal-font-medium cal-text-theme-900 cal-placeholder-theme-400 focus:cal-border-theme-400 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 dark:focus:cal-border-theme-400 sm:cal-text-sm",
          placeholder: t.placeholder,
          onBlur: i[1] || (i[1] = (r) => o("blur"))
        }, null, 40, ta), [
          [yt, l.value]
        ])
      ])
    ]));
  }
}), aa = { class: "" }, la = ["for"], ca = ["name"], oa = ["value"], na = /* @__PURE__ */ S({
  __name: "SelectInput",
  props: /* @__PURE__ */ pe({
    label: {},
    name: {},
    options: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(s) {
    const a = ke(s, "modelValue");
    return (o, l) => (n(), d("div", aa, [
      c("label", {
        for: o.name,
        class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200"
      }, x(o.label), 9, la),
      re(c("select", {
        "onUpdate:modelValue": l[0] || (l[0] = (t) => a.value = t),
        name: o.name,
        class: "cal-form-select cal-mt-2 cal-block cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-3.5 cal-text-base cal-font-medium cal-text-theme-900 cal-placeholder-theme-400 focus:cal-border-theme-400 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 dark:focus:cal-border-theme-400 sm:cal-text-sm"
      }, [
        (n(!0), d(E, null, N(o.options, (t) => (n(), d("option", {
          key: t.value,
          value: t.value
        }, x(t.label), 9, oa))), 128))
      ], 8, ca), [
        [nt, a.value]
      ])
    ]));
  }
}), sa = /* @__PURE__ */ S({
  __name: "CountrySelectInput",
  props: /* @__PURE__ */ pe({
    defaultCountry: {},
    label: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(s) {
    const a = ke(s, "modelValue"), o = s, l = T([]);
    async function t() {
      const r = await (await fetch("https://api.zaptime.app/countries", {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })).json();
      l.value = Object.keys(r.data).map((m) => ({
        value: m,
        label: r.data[m]
      })), a.value = o.defaultCountry;
    }
    return ye(async () => {
      await t();
    }), (i, r) => (n(), J(na, {
      modelValue: a.value,
      "onUpdate:modelValue": r[0] || (r[0] = (m) => a.value = m),
      label: i.label,
      options: l.value,
      name: "country"
    }, null, 8, ["modelValue", "label", "options"]));
  }
});
function it({ currency: s, price: a, calendarId: o }) {
  const { config: l } = z(o);
  return {
    priceCurrency: D(() => {
      var i;
      return new Intl.NumberFormat((i = l.value.locale) == null ? void 0 : i.preset, {
        style: "currency",
        currency: s,
        minimumFractionDigits: 0
      }).format(a / 100);
    })
  };
}
const dt = (s) => ($t("data-v-ba799e3b"), s = s(), Vt(), s), ra = {
  key: 0,
  class: "cal-mt-6"
}, ia = { class: "cal-mt-3" }, da = {
  key: 0,
  class: "cal-text-xl cal-font-semibold cal-leading-[36px] cal-text-theme-800 dark:cal-text-theme-300"
}, ua = { class: "cal-text-lg cal-font-medium cal-leading-[24px] cal-text-theme-700 dark:cal-text-theme-100" }, ma = { key: 0 }, pa = { class: "" }, ha = { class: "cal-mt-4 cal-flex cal-w-full cal-gap-3" }, fa = { class: "cal-flex cal-gap-3" }, va = { class: "cal-flex cal-gap-3" }, xa = { class: "cal-mt-12" }, ba = {
  key: 0,
  for: "card-number",
  class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200"
}, ga = /* @__PURE__ */ dt(() => /* @__PURE__ */ c("div", {
  id: "card-number",
  class: "cal- cal-mt-2 cal-h-[50px] cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-4 cal-text-base cal-font-medium cal-text-theme-900 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 sm:cal-text-sm"
}, null, -1)), _a = /* @__PURE__ */ dt(() => /* @__PURE__ */ c("div", { class: "cal-mt-3 cal-grid cal-grid-cols-2 cal-gap-3" }, [
  /* @__PURE__ */ c("div", null, [
    /* @__PURE__ */ c("div", {
      id: "card-expiry",
      class: "cal-mt-2 cal-block cal-h-[50px] cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-4 cal-text-base cal-font-medium cal-text-theme-900 cal-placeholder-theme-400 focus:cal-border-theme-400 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 sm:cal-text-sm"
    })
  ]),
  /* @__PURE__ */ c("div", null, [
    /* @__PURE__ */ c("div", {
      id: "card-cvc",
      class: "cal-mt-2 cal-block cal-h-[50px] cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-4 cal-text-base cal-font-medium cal-text-theme-900 cal-placeholder-theme-400 focus:cal-border-theme-400 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 sm:cal-text-sm"
    })
  ])
], -1)), ka = /* @__PURE__ */ S({
  __name: "Payment",
  setup(s) {
    var m, f;
    const a = T(!1), { stripeConfig: o } = fe(b("calendarId")), { config: l } = z(b("calendarId")), { billingAddress: t } = ot(b("calendarId")), { collectFormValues: i } = Z(b("calendarId")), { priceCurrency: r } = it({ price: ((m = o.value) == null ? void 0 : m.price) || 0, currency: ((f = o.value) == null ? void 0 : f.currency) || "", calendarId: b("calendarId") });
    return ae(a, () => {
      const u = i();
      console.log(u), t.value.name === "" && u.firstName !== void 0 && u.lastName !== void 0 && (console.log(u.firstName), t.value.name = u.firstName + " " + u.lastName), console.log(t.value.email), t.value.email === "" && (t.value.email = u.email);
    }), (u, h) => {
      var C, I, B, g, k, p, w;
      return n(), d(E, null, [
        (n(), J(wt, { to: "head" }, [
          (n(), J(Ct("script"), {
            src: "https://js.stripe.com/v3/",
            async: ""
          }))
        ])),
        e(o) ? (n(), d("div", ra, [
          c("div", ia, [
            (I = (C = e(l).locale) == null ? void 0 : C.confirmationForm) != null && I.payments ? (n(), d("p", da, x(e(l).locale.confirmationForm.payments.price), 1)) : _("", !0),
            c("p", ua, x(e(r)), 1)
          ]),
          a.value ? _("", !0) : (n(), d("button", {
            key: 0,
            class: "cal-mt-5 cal-rounded-md cal-bg-theme-100 cal-px-2 cal-py-1 cal-text-sm cal-font-medium cal-text-theme-600 dark:cal-bg-theme-600 dark:cal-text-theme-300",
            type: "button",
            onClick: h[0] || (h[0] = (M) => a.value = !0)
          }, x((k = (g = (B = e(l).locale) == null ? void 0 : B.confirmationForm) == null ? void 0 : g.payments) == null ? void 0 : k.showBillingDetails), 1)),
          v(we, null, {
            default: L(() => {
              var M, $;
              return [
                a.value && (($ = (M = e(l).locale) == null ? void 0 : M.confirmationForm) != null && $.payments) ? (n(), d("div", ma, [
                  c("div", pa, [
                    v(W, {
                      modelValue: e(t).name,
                      "onUpdate:modelValue": h[1] || (h[1] = (y) => e(t).name = y),
                      class: "cal-mt-4",
                      label: e(l).locale.confirmationForm.payments.name,
                      name: "name",
                      type: "text",
                      autocomplete: "name"
                    }, null, 8, ["modelValue", "label"]),
                    v(W, {
                      modelValue: e(t).email,
                      "onUpdate:modelValue": h[2] || (h[2] = (y) => e(t).email = y),
                      class: "cal-mt-4",
                      label: e(l).locale.confirmationForm.payments.email,
                      name: "email",
                      type: "text",
                      autocomplete: "email"
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  v(W, {
                    modelValue: e(t).company,
                    "onUpdate:modelValue": h[3] || (h[3] = (y) => e(t).company = y),
                    class: "cal-mt-4",
                    label: e(l).locale.confirmationForm.payments.company,
                    name: "company",
                    type: "text",
                    autocomplete: "organization"
                  }, null, 8, ["modelValue", "label"]),
                  c("div", ha, [
                    v(W, {
                      modelValue: e(t).address,
                      "onUpdate:modelValue": h[4] || (h[4] = (y) => e(t).address = y),
                      class: "cal-w-1/2",
                      label: e(l).locale.confirmationForm.payments.address,
                      name: "address",
                      type: "text",
                      autocomplete: "address-line1"
                    }, null, 8, ["modelValue", "label"]),
                    v(sa, {
                      modelValue: e(t).country,
                      "onUpdate:modelValue": h[5] || (h[5] = (y) => e(t).country = y),
                      label: e(l).locale.confirmationForm.payments.country,
                      class: "cal-w-1/2"
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  c("div", fa, [
                    v(W, {
                      modelValue: e(t).city,
                      "onUpdate:modelValue": h[6] || (h[6] = (y) => e(t).city = y),
                      class: "cal-mt-4",
                      label: e(l).locale.confirmationForm.payments.city,
                      name: "city",
                      type: "text",
                      autocomplete: "address-level2"
                    }, null, 8, ["modelValue", "label"]),
                    v(W, {
                      modelValue: e(t).postalCode,
                      "onUpdate:modelValue": h[7] || (h[7] = (y) => e(t).postalCode = y),
                      class: "cal-mt-4",
                      label: e(l).locale.confirmationForm.payments.zip,
                      name: "postalCode",
                      type: "text",
                      autocomplete: "postal-code"
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  c("div", va, [
                    v(W, {
                      modelValue: e(t).vatId,
                      "onUpdate:modelValue": h[8] || (h[8] = (y) => e(t).vatId = y),
                      class: "cal-mt-4",
                      label: e(l).locale.confirmationForm.payments.vatId,
                      name: "vatID",
                      type: "text",
                      autocomplete: "vat-id"
                    }, null, 8, ["modelValue", "label"]),
                    v(W, {
                      modelValue: e(t).crn,
                      "onUpdate:modelValue": h[9] || (h[9] = (y) => e(t).crn = y),
                      class: "cal-mt-4",
                      label: e(l).locale.confirmationForm.payments.crn,
                      name: "crn",
                      type: "text",
                      autocomplete: "crn"
                    }, null, 8, ["modelValue", "label"])
                  ])
                ])) : _("", !0)
              ];
            }),
            _: 1
          }),
          c("div", xa, [
            (w = (p = e(l).locale) == null ? void 0 : p.confirmationForm) != null && w.payments ? (n(), d("label", ba, x(e(l).locale.confirmationForm.payments.cardNumber), 1)) : _("", !0),
            ga
          ]),
          _a
        ])) : _("", !0)
      ], 64);
    };
  }
}), ya = /* @__PURE__ */ $e(ka, [["__scopeId", "data-v-ba799e3b"]]), wa = ["for"], Ca = { class: "cal-mt-2" }, $a = ["required", "type", "name", "placeholder"], Va = /* @__PURE__ */ S({
  __name: "TextInput",
  props: {
    label: {},
    name: {},
    uuid: {},
    type: {},
    required: { type: Boolean },
    mergeTag: {},
    placeholder: {},
    options: {},
    value: { type: [String, Number, Boolean, Array] }
  },
  setup(s) {
    const a = s, { setCustomFieldValue: o } = Z(b("calendarId"));
    function l(t) {
      t.target instanceof HTMLInputElement && o(a.uuid, t.target.value);
    }
    return (t, i) => (n(), d("div", null, [
      c("label", {
        for: t.uuid,
        class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200"
      }, x(t.label), 9, wa),
      c("div", Ca, [
        c("input", {
          required: t.required,
          type: t.type,
          name: t.uuid,
          autocomplete: "off",
          class: "cal-block cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-3.5 cal-text-base cal-font-medium cal-text-theme-900 cal-placeholder-theme-400 focus:cal-border-theme-400 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 dark:focus:cal-border-theme-400 sm:cal-text-sm",
          placeholder: t.placeholder,
          onInput: l
        }, null, 40, $a)
      ])
    ]));
  }
}), Sa = { class: "cal-relative cal-flex cal-items-start" }, Ia = { class: "cal-flex cal-h-6 cal-items-center" }, Ma = ["id", "name", "required"], Ta = { class: "cal-ml-3 cal-text-sm cal-leading-6" }, Fa = ["for", "innerHTML"], Ba = /* @__PURE__ */ S({
  __name: "Checkbox",
  props: {
    label: {},
    name: {},
    uuid: {},
    type: {},
    required: { type: Boolean },
    mergeTag: {},
    placeholder: {},
    options: {},
    value: { type: [String, Number, Boolean, Array] }
  },
  setup(s) {
    const a = s, { setCustomFieldValue: o } = Z(b("calendarId"));
    function l(t) {
      t.target instanceof HTMLInputElement && o(a.uuid, t.target.checked);
    }
    return (t, i) => (n(), d("div", Sa, [
      c("div", Ia, [
        c("input", {
          id: t.uuid,
          name: t.uuid,
          type: "checkbox",
          required: t.required,
          class: "cal-form-checkbox cal-h-5 cal-w-5 cal-rounded-md cal-border cal-border-theme-400 cal-ring-opacity-25 checked:cal-border-none checked:cal-bg-accent-base focus:cal-ring-1 focus:cal-ring-accent-light dark:cal-border-theme-300",
          onChange: l
        }, null, 40, Ma)
      ]),
      c("div", Ta, [
        c("label", {
          for: t.uuid,
          class: "zaptime-checkbox-label cal-text-theme-700 dark:cal-text-theme-400",
          innerHTML: t.label
        }, null, 8, Fa)
      ])
    ]));
  }
}), La = ["for"], Ha = { class: "cal-mt-2" }, za = ["name", "required", "placeholder"], ja = /* @__PURE__ */ S({
  __name: "Textarea",
  props: {
    label: {},
    name: {},
    uuid: {},
    type: {},
    required: { type: Boolean },
    mergeTag: {},
    placeholder: {},
    options: {},
    value: { type: [String, Number, Boolean, Array] }
  },
  setup(s) {
    const a = s, { setCustomFieldValue: o } = Z(b("calendarId"));
    function l(t) {
      t.target instanceof HTMLTextAreaElement && o(a.uuid, t.target.value);
    }
    return (t, i) => (n(), d("div", null, [
      c("label", {
        for: t.uuid,
        class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200"
      }, x(t.label), 9, La),
      c("div", Ha, [
        c("textarea", {
          name: t.uuid,
          required: t.required,
          class: "cal-block cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-3.5 cal-text-base cal-font-medium cal-text-theme-900 cal-placeholder-theme-400 focus:cal-border-theme-400 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 dark:focus:cal-border-theme-400 sm:cal-text-sm",
          placeholder: t.placeholder,
          onInput: l
        }, null, 40, za)
      ])
    ]));
  }
}), Da = { key: 0 }, Aa = ["for"], Pa = ["name", "required"], Ea = ["value"], Ua = /* @__PURE__ */ S({
  __name: "Select",
  props: {
    label: {},
    name: {},
    uuid: {},
    type: {},
    required: { type: Boolean },
    mergeTag: {},
    placeholder: {},
    options: {},
    value: { type: [String, Number, Boolean, Array] }
  },
  setup(s) {
    const a = s, o = T(String(a.value)), { setCustomFieldValue: l } = Z(b("calendarId"));
    return ae(o, (t) => {
      t !== void 0 && l(a.uuid, t);
    }), (t, i) => t.options ? (n(), d("div", Da, [
      c("label", {
        for: t.name,
        class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200"
      }, x(t.label), 9, Aa),
      re(c("select", {
        "onUpdate:modelValue": i[0] || (i[0] = (r) => o.value = r),
        name: t.name,
        required: t.required,
        class: "cal-form-select cal-mt-2 cal-block cal-w-full cal-rounded-md cal-border cal-border-theme-300 cal-bg-theme-50 cal-px-5 cal-py-3.5 cal-text-base cal-font-medium cal-text-theme-900 cal-placeholder-theme-400 focus:cal-border-theme-400 focus:cal-outline-none focus:cal-ring-theme-500 dark:cal-border-theme-600 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:cal-placeholder-theme-500 dark:focus:cal-border-theme-400 sm:cal-text-sm"
      }, [
        (n(!0), d(E, null, N(t.options, (r, m) => (n(), d("option", {
          key: m,
          value: r
        }, x(r), 9, Ea))), 128))
      ], 8, Pa), [
        [nt, o.value]
      ])
    ])) : _("", !0);
  }
}), Na = { class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200" }, qa = { class: "cal-flex cal-h-6 cal-items-center" }, Za = ["id", "name", "onChange"], Ra = { class: "cal-ml-3 cal-text-sm cal-leading-6" }, Oa = ["for", "innerHTML"], Ga = /* @__PURE__ */ S({
  __name: "Multiselect",
  props: {
    label: {},
    name: {},
    uuid: {},
    type: {},
    required: { type: Boolean },
    mergeTag: {},
    placeholder: {},
    options: {},
    value: { type: [String, Number, Boolean, Array] }
  },
  setup(s) {
    const a = s, { setCustomFieldValue: o } = Z(b("calendarId")), l = T([]);
    function t(i) {
      if (a.options === void 0)
        return;
      const r = a.options[i];
      l.value = l.value.includes(r) ? l.value.filter((m) => m !== r) : [...l.value, r], o(a.uuid, l.value);
    }
    return (i, r) => (n(), d("div", null, [
      c("label", Na, x(i.label), 1),
      (n(!0), d(E, null, N(i.options, (m, f) => (n(), d("div", {
        key: i.uuid + "_" + f,
        class: "cal-relative cal-my-2 cal-flex cal-items-center"
      }, [
        c("div", qa, [
          c("input", {
            id: i.uuid + "_" + f,
            name: i.uuid,
            type: "checkbox",
            class: "cal-form-checkbox cal-h-5 cal-w-5 cal-rounded-md cal-border cal-border-theme-400 cal-ring-opacity-25 checked:cal-border-none checked:cal-bg-accent-base focus:cal-ring-1 focus:cal-ring-accent-light dark:cal-border-theme-300",
            onChange: (u) => t(f)
          }, null, 40, Za)
        ]),
        c("div", Ra, [
          c("label", {
            for: i.uuid + "_" + f,
            class: "cal-block cal-text-sm cal-text-theme-500 dark:cal-text-theme-200",
            innerHTML: m
          }, null, 8, Oa)
        ])
      ]))), 128))
    ]));
  }
}), Wa = { class: "cal-relative" }, Ja = { class: "cal-block cal-text-sm cal-font-medium cal-text-theme-500 dark:cal-text-theme-200" }, Xa = ["id", "name", "required", "onChange"], Ya = { class: "cal-ml-3 cal-text-sm cal-leading-6" }, Qa = ["for", "innerHTML"], Ka = /* @__PURE__ */ S({
  __name: "Radio",
  props: {
    label: {},
    name: {},
    uuid: {},
    type: {},
    required: { type: Boolean },
    mergeTag: {},
    placeholder: {},
    options: {},
    value: { type: [String, Number, Boolean, Array] }
  },
  setup(s) {
    const a = s, { setCustomFieldValue: o } = Z(b("calendarId"));
    function l(t) {
      if (a.options === void 0)
        return;
      const i = a.options.find((r, m) => m === t);
      i && o(a.uuid, i);
    }
    return (t, i) => (n(), d("div", Wa, [
      c("label", Ja, x(t.label), 1),
      (n(!0), d(E, null, N(t.options, (r, m) => (n(), d("div", {
        key: t.uuid + "_" + m,
        class: "cal-my-2 cal-flex cal-h-6 cal-items-center"
      }, [
        c("input", {
          id: t.uuid + "_" + m,
          name: t.uuid,
          type: "radio",
          required: t.required,
          class: "cal-form-radio cal-h-5 cal-w-5 cal-rounded-full cal-border cal-border-theme-400 cal-ring-opacity-25 checked:cal-border-none checked:cal-bg-accent-base focus:cal-ring-1 focus:cal-ring-accent-light dark:cal-border-theme-300",
          onChange: (f) => l(m)
        }, null, 40, Xa),
        c("div", Ya, [
          c("label", {
            for: t.uuid + "_" + m,
            class: "cal-block cal-text-sm cal-text-theme-500 dark:cal-text-theme-200",
            innerHTML: r
          }, null, 8, Qa)
        ])
      ]))), 128))
    ]));
  }
}), el = {
  key: 0,
  class: "cal-mt-4"
}, tl = {
  key: 1,
  class: "cal-mt-4"
}, al = {
  key: 2,
  class: "cal-mt-4"
}, ll = {
  key: 3,
  class: "cal-mt-4"
}, cl = {
  key: 4,
  class: "cal-mt-4"
}, ol = {
  key: 5,
  class: "cal-mt-4"
}, nl = /* @__PURE__ */ S({
  __name: "FormBuilder",
  setup(s) {
    const { bookingForm: a } = Z(b("calendarId"));
    return (o, l) => (n(), d("div", null, [
      (n(!0), d(E, null, N(e(a), (t) => (n(), d("div", {
        key: t.uuid
      }, [
        t.type === "phone" || t.type === "text" || t.type === "email" ? (n(), d("div", el, [
          v(Va, ee(te(t)), null, 16)
        ])) : _("", !0),
        t.type === "checkbox" ? (n(), d("div", tl, [
          v(Ba, ee(te(t)), null, 16)
        ])) : _("", !0),
        t.type === "textarea" ? (n(), d("div", al, [
          v(ja, ee(te(t)), null, 16)
        ])) : _("", !0),
        t.type === "select" ? (n(), d("div", ll, [
          v(Ua, ee(te(t)), null, 16)
        ])) : _("", !0),
        t.type === "multiselect" ? (n(), d("div", cl, [
          v(Ga, ee(te(t)), null, 16)
        ])) : _("", !0),
        t.type === "radio" ? (n(), d("div", ol, [
          v(Ka, ee(te(t)), null, 16)
        ])) : _("", !0)
      ]))), 128))
    ]));
  }
});
class ue extends Error {
  constructor(a) {
    super(), this.name = "error", this.message = a || "Payment failed";
  }
}
function sl() {
  var k;
  const s = T(), a = T(), o = T(), l = T(), t = T(), i = T(), r = T(), { config: m } = z(b("calendarId")), f = ((k = m.value.theme) == null ? void 0 : k.mode) === "dark", u = {
    focus: "focused",
    empty: "empty",
    invalid: "invalid"
  }, h = "https://api.zaptime.app/", C = D(() => m.value.apiBaseUrl || h), I = D(() => ({
    base: {
      // @ts-expect-error values are actually required
      color: f ? m.value.theme.colors[100] : m.value.theme.colors[900],
      fontWeight: 600,
      fontFamily: '"Basier Circle", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      fontSize: "14px",
      fontSmoothing: "antialiased",
      "::placeholder": {
        // @ts-expect-error values are actually required
        color: f ? m.value.theme.colors[500] : m.value.theme.colors[400]
      },
      ":-webkit-autofill": {
        // @ts-expect-error values are actually required
        color: f ? m.value.theme.colors[500] : m.value.theme.colors[900]
      },
      ":focus": {}
    },
    invalid: {
      color: "#E25950",
      "::placeholder": {
        color: "#FFCCA5"
      }
    }
  }));
  async function B(p) {
    l.value = Stripe("pk_live_51JsOKHJ9tIQH9YIAlLi8C4w4S2lgXIqJKlfN2Im6kFNdzqOJH5ucC8gwlwztYLr8jW9b0pDhXasYX4BXUaaRQJjj009Rgl93Z1", {
      stripeAccount: p
    }), o.value = l.value.elements(), t.value = o.value.create("cardNumber", {
      style: I.value,
      classes: u
    }), i.value = o.value.create("cardExpiry", {
      style: I.value,
      classes: u
    }), r.value = o.value.create("cardCvc", {
      style: I.value,
      classes: u
    }), t.value.mount("#card-number"), i.value.mount("#card-expiry"), r.value.mount("#card-cvc");
  }
  async function g({ billingAddress: p, reservationUuid: w }) {
    if (l.value === void 0 || t.value === void 0)
      return;
    let M;
    try {
      const y = await fetch(C.value + `api/reservations/${w}/payments`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + m.value.token,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          email: p.email,
          name: p.name,
          company: p.company || void 0,
          street: p.address || void 0,
          city: p.city || void 0,
          postalCode: p.postalCode || void 0,
          country: p.country,
          taxId: p.vatId || void 0,
          crn: p.crn || void 0
        })
      }), { data: H } = await y.json();
      M = H.clientSecret;
    } catch {
      throw new ue("Zaptime Payment Confirmation API Failed.");
    }
    if (M === void 0)
      throw new ue("Client secret is undefined.");
    const { error: $ } = await l.value.confirmCardPayment(M, {
      payment_method: {
        card: t.value,
        billing_details: {
          name: p.name,
          email: p.email,
          address: {
            postal_code: p.postalCode,
            city: p.city,
            country: p.country,
            line1: p.address
          }
        }
      }
    });
    if ($ !== void 0)
      throw new ue($ == null ? void 0 : $.message);
  }
  return {
    initGateway: B,
    handleSubmit: g,
    errors: a,
    result: s
  };
}
const rl = { class: "cal-text-2xl cal-font-medium cal-text-theme-500 dark:cal-text-theme-500" }, il = { class: "cal-mt-[24px] cal-text-2xl cal-font-semibold cal-text-theme-700 dark:cal-text-theme-100" }, dl = { class: "cal-text-[24px] cal-font-semibold cal-leading-[36px] cal-text-theme-500 dark:cal-text-theme-300" }, ul = { key: 0 }, ml = {
  key: 1,
  class: "cal-my-5 cal-text-lg cal-text-red-500"
}, pl = { class: "cal-mt-[32px] cal-flex cal-justify-between" }, hl = { class: "cal-text-2xl cal-font-medium cal-text-theme-500 dark:cal-text-theme-500" }, fl = { class: "cal-mt-5 cal-text-2xl cal-font-medium cal-text-theme-700 dark:cal-text-theme-100" }, vl = { class: "cal-text-[24px] cal-font-medium cal-leading-[36px] cal-text-theme-500 dark:cal-text-theme-300" }, xl = /* @__PURE__ */ c("div", { class: "cal-my-2 cal-flex" }, [
  /* @__PURE__ */ c("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "lucide lucide-arrow-up cal-rotate-180 cal-text-theme-500 dark:cal-text-theme-100"
  }, [
    /* @__PURE__ */ c("path", { d: "m5 12 7-7 7 7" }),
    /* @__PURE__ */ c("path", { d: "M12 19V5" })
  ])
], -1), bl = { class: "cal-text-2xl cal-font-medium cal-text-theme-700 dark:cal-text-theme-100" }, gl = { class: "cal-text-[24px] cal-font-medium cal-leading-[36px] cal-text-theme-500 dark:cal-text-theme-300" }, _l = { class: "cal-mt-[32px] cal-flex cal-justify-between" }, kl = /* @__PURE__ */ S({
  __name: "ConfirmForm",
  emits: ["booking-confirmed", "go-back"],
  setup(s, { emit: a }) {
    const o = a, { selectedTimeSlot: l } = ge(b("calendarId")), { getFormattedTime: t, getFormattedDayInMonth: i } = le(), { config: r } = z(b("calendarId")), { locations: m } = _e(b("calendarId")), { stripeConfig: f } = fe(b("calendarId")), { collectFormValues: u } = Z(b("calendarId")), { billingAddress: h } = ot(b("calendarId")), { reservation: C } = ve(b("calendarId")), { initGateway: I, handleSubmit: B } = sl(), g = b("color2"), k = b("calendarId"), p = T(1), w = T(!1), M = Ve(), $ = T(!1);
    class y extends Error {
      constructor() {
        super(), this.name = "ValidationError";
      }
    }
    const H = D(() => {
      if (r !== void 0)
        return r.value.locale;
    });
    async function X() {
      try {
        const F = u(), q = await ft({
          ...F,
          seats: p.value,
          calendarId: k,
          location: m.value[0]
        });
        if (h.value.email === "" && (h.value.email = F.email), h.value.name === "" && (h.value.name = F.firstName + " " + F.lastName), h.value.country === "" && (h.value.country = "CZ"), !q.success)
          throw new y();
        await B({ billingAddress: h.value, reservationUuid: q.data.uuid });
        const G = await vt({ calendarId: k });
        if (!G.success)
          throw new Error("Failed to confirm");
        return G;
      } catch (F) {
        throw F instanceof ue && (console.error(F.message), await xt(k)), new Error("Failed to reserve");
      }
    }
    async function Y() {
      w.value = !0;
      try {
        let F;
        if (f.value)
          F = await X();
        else if (F = await pt({
          seats: p.value,
          calendarId: k,
          location: m.value[0],
          ...u()
        }), !F.success)
          throw new y();
        M == null || M.track("booking_confirmed", {
          timeSlot: l.value ? l.value.start : void 0
        }), o("booking-confirmed", F), w.value = !1;
      } catch (F) {
        if (F instanceof y) {
          console.error("Booking failed! Please try again or contact support.");
          return;
        }
        $.value = !0, console.error(F);
      } finally {
        w.value = !1;
      }
    }
    async function R() {
      w.value = !0;
      const F = await ht(k);
      o("booking-confirmed", F), w.value = !1;
    }
    return ye(async () => {
      f.value && setTimeout(async () => {
        I(f.value.stripeAccountId);
      }, 500);
    }), (F, q) => {
      var G, ce, oe, ne;
      return n(), d("div", {
        class: V(["cal-flex cal-h-full cal-min-h-[524px] cal-justify-center cal-rounded-xl cal-bg-white cal-px-[20px] cal-pb-10 dark:cal-bg-theme-900 sm:cal-px-6", [e(r).compact ? "cal-w-[330px] sm:cal-w-[400px]" : "cal-w-[330px] sm:cal-w-[840px]"]]),
        style: se({ backgroundColor: e(g) })
      }, [
        !e(C) && e(l) !== void 0 ? (n(), d("form", {
          key: 0,
          class: V(["cal-mt-12 cal-flex-col sm:cal-w-[370px]", [e(l).seats > 1 ? "cal-mt-8" : "cal-mt-20"]]),
          onSubmit: Q(Y, ["prevent"])
        }, [
          c("h1", rl, x((ce = (G = H.value) == null ? void 0 : G.confirmationForm) == null ? void 0 : ce.confirmBooking), 1),
          c("h2", il, x(e(i)(e(l).start)), 1),
          c("h3", dl, x(e(t)(e(l).start)) + " - " + x(e(t)(e(l).end)), 1),
          v(nl, { class: "" }),
          e(f) ? (n(), d("div", ul, [
            v(ya)
          ])) : _("", !0),
          $.value ? (n(), d("div", ml, " Payment has failed ")) : _("", !0),
          c("div", pl, [
            v(Ye, {
              type: "button",
              disabled: w.value,
              onClick: q[0] || (q[0] = (j) => o("go-back"))
            }, {
              default: L(() => {
                var j, A, P;
                return [
                  O(x((P = (A = (j = H.value) == null ? void 0 : j.confirmationForm) == null ? void 0 : A.buttons) == null ? void 0 : P.goBack), 1)
                ];
              }),
              _: 1
            }, 8, ["disabled"]),
            v(he, {
              loading: w.value,
              type: "submit"
            }, {
              default: L(() => {
                var j, A, P;
                return [
                  O(x((P = (A = (j = H.value) == null ? void 0 : j.confirmationForm) == null ? void 0 : A.buttons) == null ? void 0 : P.confirmBooking), 1)
                ];
              }),
              _: 1
            }, 8, ["loading"])
          ])
        ], 34)) : _("", !0),
        e(C) && e(l) !== void 0 ? (n(), d("form", {
          key: 1,
          class: "cal-mt-20 sm:cal-w-[280px]",
          onSubmit: Q(R, ["prevent"])
        }, [
          c("h1", hl, x((ne = (oe = H.value) == null ? void 0 : oe.confirmationForm) == null ? void 0 : ne.reschedulingEvent), 1),
          c("p", fl, x(e(i)(e(C).start)), 1),
          c("p", vl, x(e(t)(e(C).start)) + " - " + x(e(t)(e(C).end)), 1),
          xl,
          c("h2", bl, x(e(i)(e(l).start)), 1),
          c("h3", gl, x(e(t)(e(l).start)) + " - " + x(e(t)(e(l).end)), 1),
          c("div", _l, [
            v(Ye, {
              disabled: w.value,
              type: "button",
              onClick: q[1] || (q[1] = (j) => o("go-back"))
            }, {
              default: L(() => {
                var j, A, P;
                return [
                  O(x((P = (A = (j = H.value) == null ? void 0 : j.confirmationForm) == null ? void 0 : A.buttons) == null ? void 0 : P.goBack), 1)
                ];
              }),
              _: 1
            }, 8, ["disabled"]),
            v(he, {
              loading: w.value,
              type: "submit"
            }, {
              default: L(() => {
                var j, A, P;
                return [
                  O(x((P = (A = (j = H.value) == null ? void 0 : j.confirmationForm) == null ? void 0 : A.buttons) == null ? void 0 : P.reschedule), 1)
                ];
              }),
              _: 1
            }, 8, ["loading"])
          ])
        ], 32)) : _("", !0)
      ], 6);
    };
  }
}), yl = {
  key: 0,
  class: "cal-mt-6 cal-flex cal-items-center cal-justify-between cal-gap-2 cal-px-2.5"
}, wl = { class: "cal-flex cal-w-full cal-gap-2" }, Cl = ["innerHTML"], $l = { class: "cal-text-sm cal-text-theme-600 dark:cal-text-theme-200" }, Vl = {
  key: 0,
  class: "cal-flex cal-shrink-0 cal-items-center cal-gap-1.5"
}, Sl = /* @__PURE__ */ c("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.75",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-credit-card cal-text-theme-600 dark:cal-text-theme-200"
}, [
  /* @__PURE__ */ c("rect", {
    width: "20",
    height: "14",
    x: "2",
    y: "5",
    rx: "2"
  }),
  /* @__PURE__ */ c("line", {
    x1: "2",
    x2: "22",
    y1: "10",
    y2: "10"
  })
], -1), Il = { class: "cal-text-sm cal-text-theme-600 dark:cal-text-theme-200" }, Ml = /* @__PURE__ */ S({
  __name: "MeetingInformation",
  setup(s) {
    var f, u;
    const { locations: a } = _e(b("calendarId")), { stripeConfig: o } = fe(b("calendarId")), { config: l } = z(b("calendarId")), { priceCurrency: t } = it({ price: ((f = o.value) == null ? void 0 : f.price) || 0, currency: ((u = o.value) == null ? void 0 : u.currency) || "", calendarId: b("calendarId") }), i = D(() => {
      var h, C;
      if (((h = r.value) == null ? void 0 : h.id) === "in-person" || ((C = r.value) == null ? void 0 : C.id) === "phone")
        return a.value[0].value;
      if (r.value)
        return r.value.name;
    }), r = D(() => {
      if (a.value && a.value.length > 0)
        return m.value.find((h) => h.id === a.value[0].type);
    }), m = T([
      {
        id: "no-location",
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-off"><path d="M5.43 5.43A8.06 8.06 0 0 0 4 10c0 6 8 12 8 12a29.94 29.94 0 0 0 5-5"/><path d="M19.18 13.52A8.66 8.66 0 0 0 20 10a8 8 0 0 0-8-8 7.88 7.88 0 0 0-3.52.82"/><path d="M9.13 9.13A2.78 2.78 0 0 0 9 10a3 3 0 0 0 3 3 2.78 2.78 0 0 0 .87-.13"/><path d="M14.9 9.25a3 3 0 0 0-2.15-2.16"/><line x1="2" x2="22" y1="2" y2="22"/></svg>',
        name: "No Location"
      },
      {
        id: "google-meet",
        icon: '<svg viewBox="0 0 24 24"><g fill-rule="nonzero" fill="none"><path fill="#188038" d="M13.58 11.87l2.33 2.68 3.15 2 .55-4.66-.55-4.56-3.2 1.76z"></path><path d="M0 16.12v3.98c0 .91.74 1.65 1.65 1.65h3.97l.82-3.01-.82-2.62-2.73-.82-2.89.82z" fill="#1967D2"></path><path fill="#EA4335" d="M5.62 2L0 7.62l2.9.82 2.72-.82.81-2.58z"></path><path fill="#4285F4" d="M5.62 7.62H0v8.5h5.62z"></path><path d="M22.65 4.38l-3.59 2.95v9.23l3.61 2.96a.82.82 0 001.33-.65V5.02c0-.7-.8-1.08-1.35-.64zm-9.07 7.5v4.24H5.62v5.63h11.8c.9 0 1.64-.74 1.64-1.65v-3.54l-5.48-4.69z" fill="#34A853"></path><path d="M17.42 2H5.62v5.62h7.96v4.25l5.48-4.54V3.65c0-.91-.74-1.65-1.64-1.65z" fill="#FBBC04"></path></g></svg>',
        name: "Google Meet"
      },
      {
        id: "zoom",
        icon: '<svg viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="#2D8CFF" d="M6.55 0A6.55 6.55 0 000 6.55v10.9A6.55 6.55 0 006.55 24h10.9A6.55 6.55 0 0024 17.45V6.55A6.55 6.55 0 0017.45 0H6.55z"></path><path fill="#fff" d="M6 8a1 1 0 00-1 1v4a3 3 0 003 3h6a1 1 0 001-1v-4a3 3 0 00-3-3H6zM18.22 8.18L15.94 9.7a1 1 0 00-.44.83v2.93a1 1 0 00.44.83l2.28 1.55a.5.5 0 00.78-.41V8.59a.5.5 0 00-.09-.28.5.5 0 00-.41-.22.5.5 0 00-.28.09z"></path></g></svg>',
        name: "Zoom"
      },
      {
        id: "phone",
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>`,
        name: "Phone Call"
      },
      {
        id: "in-person",
        icon: '<svg class="cal-text-theme-600 dark:cal-text-theme-200" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
        name: "In-Person Meeting"
      }
    ]);
    return (h, C) => {
      var I;
      return r.value && r.value.id !== "no-location" && !e(l).hideLocation ? (n(), d("div", yl, [
        c("div", wl, [
          c("div", {
            class: "cal-h-5 cal-w-5 dark:cal-text-theme-200",
            innerHTML: (I = r.value) == null ? void 0 : I.icon
          }, null, 8, Cl),
          c("p", $l, x(i.value), 1)
        ]),
        e(o) ? (n(), d("div", Vl, [
          Sl,
          c("p", Il, x(e(t)), 1)
        ])) : _("", !0)
      ])) : _("", !0);
    };
  }
}), Tl = { key: 0 }, Fl = {
  key: 0,
  class: "cal-mb-3 cal-flex cal-w-full cal-justify-center cal-pt-3"
}, Bl = ["src"], Ll = ["innerHTML"], Hl = {
  key: 1,
  class: "cal-px-3"
}, zl = { class: "cal-text-base cal-font-medium cal-tracking-tighter cal-text-theme-600 dark:cal-text-theme-200" }, jl = {
  key: 0,
  class: "cal-text-lg cal-font-semibold cal-tracking-tighter cal-text-theme-600 dark:cal-text-theme-200"
}, Dl = { class: "cal-flex cal-justify-between cal-py-4" }, Al = { class: "cal-ml-3 cal-text-base cal-font-medium cal-text-theme-900 dark:cal-text-theme-200" }, Pl = { class: "cal-mr-1 cal-flex" }, El = ["disabled"], Ul = /* @__PURE__ */ c("svg", {
  class: "cal-h-6 cal-w-6 cal-rotate-180 cal-text-accent-dark hover:cal-text-accent-base",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ c("path", {
    d: "M9 18L15 12L9 6",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), Nl = [
  Ul
], ql = ["disabled"], Zl = /* @__PURE__ */ c("svg", {
  class: "cal-h-6 cal-w-6 cal-text-accent-dark hover:cal-text-accent-base",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ c("path", {
    d: "M9 18L15 12L9 6",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), Rl = [
  Zl
], Ke = /* @__PURE__ */ S({
  __name: "Navbar",
  setup(s) {
    const { monthName: a, currentYear: o, prev: l, prevDisabled: t, next: i, nextDisabled: r } = K(b("calendarId")), { config: m } = z(b("calendarId")), { reservation: f } = ve(b("calendarId")), { getFormattedTime: u, getFormattedDayInMonth: h } = le();
    return (C, I) => {
      var B, g, k, p, w, M;
      return n(), d(E, null, [
        c("div", {
          class: V([e(m).profileImage && !e(f) ? "" : "cal-pt-6"])
        }, [
          e(f) ? (n(), d("div", Hl, [
            c("p", zl, x((M = (w = e(m).locale) == null ? void 0 : w.confirmationForm) == null ? void 0 : M.reschedulingEvent), 1),
            e(f) ? (n(), d("div", jl, x(e(h)(e(f).start)) + " " + x(e(u)(e(f).start)) + " - " + x(e(u)(e(f).end)), 1)) : _("", !0)
          ])) : (n(), d("div", Tl, [
            e(m).profileImage ? (n(), d("div", Fl, [
              c("img", {
                class: "cal-h-[96px] cal-w-[96px] cal-rounded-full cal-object-cover cal-object-top",
                src: e(m).profileImage,
                loading: "lazy",
                alt: "Profile image"
              }, null, 8, Bl)
            ])) : _("", !0),
            (g = (B = e(m).locale) == null ? void 0 : B.texts) != null && g.introduction ? (n(), d("div", {
              key: 1,
              class: V(["cal-w-full cal-text-center cal-text-theme-600 dark:cal-text-theme-200", [e(m).profileImage ? "" : "cal-py-12"]]),
              innerHTML: (p = (k = e(m).locale) == null ? void 0 : k.texts) == null ? void 0 : p.introduction
            }, null, 10, Ll)) : _("", !0),
            v(Ml)
          ]))
        ], 2),
        c("div", Dl, [
          c("p", Al, x(e(a)) + " " + x(e(o)), 1),
          c("div", Pl, [
            e(t) ? _("", !0) : (n(), d("button", {
              key: 0,
              disabled: e(t),
              class: V([{ "cal-cursor-not-allowed": e(t) }, "cal-flex cal-items-center cal-justify-center"]),
              onClick: I[0] || (I[0] = Q(
                //@ts-ignore
                (...$) => e(l) && e(l)(...$),
                ["prevent"]
              ))
            }, Nl, 10, El)),
            e(r) ? _("", !0) : (n(), d("button", {
              key: 1,
              disabled: e(r),
              class: V([{ "cal-cursor-not-allowed": e(r) }, "cal-flex cal-items-center cal-justify-center"]),
              onClick: I[1] || (I[1] = Q(
                //@ts-ignore
                (...$) => e(i) && e(i)(...$),
                ["prevent"]
              ))
            }, Rl, 10, ql))
          ])
        ])
      ], 64);
    };
  }
}), et = /* @__PURE__ */ S({
  __name: "Header",
  setup(s) {
    const { state: a } = K(b("calendarId"));
    return (o, l) => (n(!0), d(E, null, N(e(a).headers, (t) => (n(), d("div", {
      key: t,
      class: "tracking-[-0.01em] cal-flex cal-justify-center cal-text-[13px] cal-font-medium cal-text-theme-900 dark:cal-text-theme-300"
    }, x(t), 1))), 128));
  }
}), Ol = {
  key: 1,
  class: "w-full cal-flex cal-items-center cal-space-x-2"
}, Gl = {
  key: 0,
  class: "cal-absolute cal-right-5 cal-h-6 cal-w-6",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, Wl = /* @__PURE__ */ c("path", {
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
}, null, -1), Jl = [
  Wl
], Xl = /* @__PURE__ */ S({
  __name: "TimeConfirmationButton",
  props: {
    timeSlot: {}
  },
  emits: ["selectTimeSlot"],
  setup(s, { emit: a }) {
    const { getFormattedTime: o } = le(), { isSelected: l } = K(b("calendarId")), { config: t } = z(b("calendarId")), i = T(), r = T(!1), m = a;
    return Lt(i, () => {
      r.value = !1;
    }), (f, u) => (n(), d("div", null, [
      e(t).externalBooking ? (n(), d("div", Ol, [
        c("button", {
          class: V(["cal-group cal-relative cal-my-2 cal-inline-flex cal-w-full cal-cursor-pointer cal-items-center cal-justify-center cal-rounded-md cal-font-medium cal-outline-none cal-ring-offset-2 cal-transition-all cal-duration-150 cal-ease-out focus:cal-outline-none focus:cal-ring-2 focus:cal-ring-accent-base dark:cal-ring-offset-theme-700", [e(l)(f.timeSlot) ? "cal-bg-accent-base cal-text-white" : "cal-bg-theme-100 cal-text-theme-700 hover:cal-bg-theme-200 hover:cal-text-accent-base dark:cal-bg-theme-800 hover:dark:cal-bg-theme-600"]]),
          onClick: u[2] || (u[2] = Q((h) => m("selectTimeSlot"), ["prevent"]))
        }, [
          c("span", {
            class: V(["cal-flex cal-items-center cal-py-4 cal-leading-4", {
              "cal-text-white ": e(l)(f.timeSlot),
              "cal-text-theme-800 dark:cal-text-theme-100": !e(l)(f.timeSlot)
            }])
          }, x(e(o)(f.timeSlot.start)) + " - " + x(e(o)(f.timeSlot.end)), 3),
          e(l)(f.timeSlot) ? (n(), d("svg", Gl, Jl)) : _("", !0)
        ], 2)
      ])) : (n(), d("div", {
        key: 0,
        ref_key: "target",
        ref: i,
        class: "w-full cal-flex cal-items-center cal-space-x-2"
      }, [
        c("button", {
          class: V(["cal-group cal-my-2 cal-inline-flex cal-cursor-pointer cal-items-center cal-justify-center cal-rounded-md cal-bg-theme-100 cal-font-medium cal-outline-none cal-transition-all cal-duration-150 cal-ease-out focus:cal-outline-none focus:cal-ring-2 focus:cal-ring-theme-800 focus:cal-ring-opacity-50 dark:cal-border-theme-600 dark:cal-bg-theme-800", [
            e(l)(f.timeSlot) ? "cal-bg-accent-base cal-text-white" : "cal-bg-theme-100 cal-text-theme-700 hover:cal-bg-theme-200 hover:cal-text-accent-base hover:dark:cal-bg-theme-600",
            r.value ? " cal-w-1/2" : "cal-w-full"
          ]]),
          onClick: u[0] || (u[0] = Q((h) => r.value = !0, ["prevent"]))
        }, [
          c("span", {
            class: V(["cal-flex cal-items-center cal-py-4 cal-leading-4", {
              "cal-text-theme-700 dark:cal-text-white ": e(l)(f.timeSlot),
              "cal-text-theme-800 dark:cal-text-theme-100": !e(l)(f.timeSlot)
            }])
          }, x(e(o)(f.timeSlot.start)) + " - " + x(e(o)(f.timeSlot.end)), 3)
        ], 2),
        re(v(he, {
          class: "cal-inline-flex cal-h-12 cal-w-1/2 cal-justify-center",
          onClick: u[1] || (u[1] = (h) => m("selectTimeSlot"))
        }, {
          default: L(() => {
            var h;
            return [
              O(x(e(t).locale && ((h = e(t).locale.texts) == null ? void 0 : h.pickTime)), 1)
            ];
          }),
          _: 1
        }, 512), [
          [st, r.value]
        ])
      ], 512))
    ]));
  }
});
function Yl(s, a) {
  return n(), d("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const Ql = { class: "cal-w-full" }, Kl = { class: "cal-relative cal-mt-1" }, ec = { class: "cal-relative cal-w-full cal-cursor-default cal-overflow-hidden cal-rounded-md cal-bg-white cal-text-left focus:cal-outline-none focus:cal-ring-accent-base focus-visible:cal-ring-2 focus-visible:cal-ring-accent-base focus-visible:cal-ring-opacity-75 focus-visible:cal-ring-offset-2 focus-visible:cal-ring-offset-teal-300 dark:cal-bg-theme-700 sm:cal-text-sm" }, tc = {
  key: 0,
  class: "cal-relative cal-cursor-default cal-select-none cal-px-4 cal-py-2 cal-text-theme-700 dark:cal-text-theme-100"
}, ac = /* @__PURE__ */ S({
  __name: "TimeZonePicker",
  setup(s) {
    const { timezone: a, setTimezone: o } = bt(), { getDays: l } = K(b("calendarId")), { config: t } = z(b("calendarId")), i = T([]), r = T(""), m = T();
    ae(a, () => {
      l();
    });
    const f = Ht(
      (g) => {
        console.log("test"), r.value = g;
      },
      500,
      { maxWait: 5e3 }
    );
    function u(g) {
      o(g);
    }
    async function h() {
      try {
        const g = t.value.apiBaseUrl || "https://api.zaptime.app/", p = await (await fetch(g + "timezones")).json();
        i.value = p.data;
      } catch (g) {
        console.error("Error fetching timezones", g);
      }
    }
    async function C() {
      i.value.length === 0 && await h();
    }
    function I() {
      const g = document.querySelector("#zaptime-timezone-picker");
      g && g.select();
    }
    const B = D(() => r.value === "" ? i.value : i.value.filter((g) => g.toLowerCase().includes(r.value.toLowerCase())));
    return (g, k) => (n(), d("div", Ql, [
      v(e(zt), {
        "model-value": e(a),
        "onUpdate:modelValue": u,
        onMouseover: C
      }, {
        default: L(() => [
          c("div", Kl, [
            c("div", ec, [
              v(e(jt), {
                id: "zaptime-timezone-picker",
                ref_key: "selectText",
                ref: m,
                class: "cal-w-full cal-border-none cal-bg-theme-100 cal-py-2 cal-pl-3 cal-pr-10 cal-text-xs cal-leading-5 cal-text-theme-900 focus:cal-outline-none focus:cal-ring-0 dark:cal-bg-theme-800 dark:cal-text-theme-100",
                displayValue: () => e(a),
                onChange: k[0] || (k[0] = (p) => e(f)(p.target.value)),
                onFocus: I
              }, null, 8, ["displayValue"]),
              v(e(Dt), { class: "cal-absolute cal-inset-y-0 cal-right-0 cal-flex cal-items-center cal-pr-2" }, {
                default: L(() => [
                  v(e(Yl), {
                    class: "cal-h-5 cal-w-5 cal-text-theme-400",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })
            ]),
            v(e(At), {
              leave: "cal-transition cal-ease-in cal-duration-100",
              leaveFrom: "cal-opacity-100 ",
              leaveTo: "cal-opacity-0",
              enter: "cal-transition-all cal-duration-300 cal-ease-out",
              "enter-from": "cal-opacity-0 -cal-translate-y-[30px]",
              "enter-to": "cal-opacity-100 -cal-translate-y-[36px]",
              onAfterLeave: k[1] || (k[1] = (p) => r.value = "")
            }, {
              default: L(() => [
                v(e(Pt), { class: "cal-absolute -cal-top-3 cal-mt-1 cal-max-h-60 cal-w-[300px] -cal-translate-y-full cal-overflow-auto cal-rounded-md cal-border cal-border-theme-200 cal-bg-theme-100 cal-py-1 cal-pl-0 cal-text-base cal-shadow-lg cal-ring-1 cal-ring-black cal-ring-opacity-5 focus:cal-outline-none dark:cal-border-theme-600 dark:cal-bg-theme-800 sm:cal-text-sm" }, {
                  default: L(() => [
                    i.value.length === 0 && r.value !== "" ? (n(), d("div", tc, " Nothing found. ")) : _("", !0),
                    (n(!0), d(E, null, N(B.value, (p, w) => (n(), d("div", { key: w }, [
                      v(e(Et), {
                        as: "template",
                        value: p
                      }, {
                        default: L(({ selected: M, active: $ }) => [
                          c("li", {
                            class: V(["cal-relative cal-cursor-default cal-select-none cal-list-none cal-py-2 cal-pl-2 cal-pr-4", {
                              "cal-bg-accent-base cal-text-white dark:cal-text-theme-900": $,
                              "cal-text-theme-900 dark:cal-text-theme-100": !$
                            }])
                          }, [
                            c("span", {
                              class: V(["cal-block cal-truncate", { "cal-font-medium": M, "cal-font-normal": !M }])
                            }, x(p), 3)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]))), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model-value"])
    ]));
  }
}), lc = /* @__PURE__ */ c("span", { class: "cal-sr-only" }, "Use setting", -1), cc = /* @__PURE__ */ S({
  __name: "Switch",
  props: {
    modelValue: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(s, { emit: a }) {
    const o = a;
    return (l, t) => (n(), J(e(Ut), {
      as: "div",
      class: "cal-flex cal-items-center"
    }, {
      default: L(() => [
        v(e(Xe), { class: "cal-mr-1 cal-text-xs cal-text-theme-700 dark:cal-text-theme-200" }, {
          default: L(() => [
            me(l.$slots, "before")
          ]),
          _: 3
        }),
        v(e(Nt), {
          "model-value": s.modelValue,
          class: V([(s.modelValue, "cal-bg-theme-200 dark:cal-bg-theme-700"), "cal-relative cal-inline-flex cal-h-[24px] cal-w-[44px] cal-shrink-0 cal-cursor-pointer cal-rounded-full cal-border-2 cal-border-transparent cal-transition-colors cal-duration-200 cal-ease-in-out focus:cal-outline-none focus-visible:cal-ring-2 focus-visible:cal-ring-white focus-visible:cal-ring-opacity-75"]),
          "onUpdate:modelValue": t[0] || (t[0] = (i) => o("update:modelValue"))
        }, {
          default: L(() => [
            lc,
            c("span", {
              "aria-hidden": "true",
              class: V([s.modelValue ? "cal-translate-x-5" : "cal-translate-x-0", "cal-pointer-events-none cal-inline-block cal-h-[20px] cal-w-[20px] cal-transform cal-rounded-full cal-bg-white cal-shadow-lg cal-ring-0 cal-transition cal-duration-200 cal-ease-in-out dark:cal-bg-theme-100"])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["model-value", "class"]),
        v(e(Xe), { class: "cal-ml-1 cal-text-xs cal-text-theme-700 dark:cal-text-theme-200" }, {
          default: L(() => [
            me(l.$slots, "after")
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), oc = {
  key: 1,
  class: "cal-h-full"
}, nc = {
  key: 0,
  class: "cal-flex cal-h-full cal-flex-col cal-justify-between"
}, sc = { class: "cal-text-2xl cal-font-semibold cal-tracking-tighter cal-text-theme-600 dark:cal-text-theme-300" }, rc = { class: "cal-pb-0.5 cal-pt-6" }, ic = {
  key: 0,
  class: "cal-text-base cal-font-medium cal-tracking-tighter cal-text-theme-600 dark:cal-text-theme-200"
}, dc = {
  key: 0,
  class: "cal-mt-5 cal-flex cal-items-center cal-space-x-2 cal-pb-4 sm:cal-mt-0"
}, uc = {
  key: 1,
  class: "cal-w-full"
}, mc = {
  key: 0,
  class: "cal-flex cal-h-full cal-flex-col cal-items-center cal-justify-center"
}, pc = { class: "cal-mt-24 cal-flex cal-h-full cal-items-center cal-justify-center" }, hc = { class: "dark:cal-text-themered-50 cal-flex cal-h-40 cal-w-40 cal-items-center cal-justify-center cal-rounded-2xl cal-px-5" }, fc = ["innerHTML"], vc = {
  key: 1,
  class: "cal-flex cal-flex-col cal-items-center cal-justify-center"
}, xc = { class: "cal-mt-48 cal-flex cal-h-full cal-items-center cal-justify-center" }, bc = { class: "cal-flex cal-w-40 cal-flex-col cal-items-center cal-justify-center cal-rounded-2xl cal-px-7 cal-py-5 cal-text-theme-700 dark:cal-text-theme-200" }, gc = /* @__PURE__ */ c("svg", {
  width: "54",
  height: "60",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ c("path", {
    d: "M16.5 9.58332V7.33332C16.5 5.93319 16.5 5.23313 16.2275 4.69835C15.9878 4.22794 15.6054 3.84549 15.135 3.60581C14.6002 3.33332 13.9001 3.33332 12.5 3.33332H5.5C4.09987 3.33332 3.3998 3.33332 2.86502 3.60581C2.39462 3.84549 2.01217 4.22794 1.77248 4.69835C1.5 5.23313 1.5 5.93319 1.5 7.33332V14.3333C1.5 15.7335 1.5 16.4335 1.77248 16.9683C2.01217 17.4387 2.39462 17.8212 2.86502 18.0608C3.3998 18.3333 4.09987 18.3333 5.5 18.3333H9.41667M16.5 8.33332H1.5M12.3333 1.66666V4.99999M5.66667 1.66666V4.99999M14 17.5V12.5M11.5 15H16.5",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), _c = ["innerHTML"], tt = /* @__PURE__ */ S({
  __name: "TimeSelection",
  setup(s) {
    const { hourCycle: a } = gt(), { setView: o, setCalendarView: l } = Ce(b("calendarId")), { selectTimeSlot: t, state: i } = K(b("calendarId")), { config: r } = z(b("calendarId")), { getFormattedDayInMonth: m } = le(), { reservation: f } = ve(b("calendarId")), u = D({
      get() {
        return a.value === "h23";
      },
      set() {
        a.value === "h11" ? a.value = "h23" : a.value = "h11";
      }
    }), h = (I) => {
      var B;
      t(I), r.value.externalBooking !== !0 && ((B = Ve()) == null || B.track("zaptime:time_slot_selected", {
        timeSlot: I.start
      }), o("form"));
    }, C = () => {
      o("calendar"), l("pickingDate");
    };
    return (I, B) => (n(), d("div", {
      class: V(["cal-mx-auto cal-h-full cal-min-h-[524px] cal-bg-white cal-px-[20px] dark:cal-bg-theme-900 sm:cal-mx-0", [e(r).compact ? "cal-w-[330px] cal-rounded-xl sm:cal-w-[400px]" : "cal-w-[330px] cal-rounded-r-xl sm:cal-w-[440px]", e(r).profileImage ? "cal-pt-4" : "cal-pt-10"]])
    }, [
      e(r).compact === !0 ? (n(), J(he, {
        key: 0,
        class: "cal-mb-8 cal-mt-5",
        onClick: C
      }, {
        default: L(() => {
          var g, k, p;
          return [
            O(x((p = (k = (g = e(r).locale) == null ? void 0 : g.confirmationForm) == null ? void 0 : k.buttons) == null ? void 0 : p.goBack), 1)
          ];
        }),
        _: 1
      })) : _("", !0),
      e(i).loading ? _("", !0) : (n(), d("div", oc, [
        v(we, {
          "enter-active-class": "cal-duration-100 cal-transition-all cal-ease-out",
          "enter-from-class": "cal-opacity-0 cal-translate-y-[4px]",
          "enter-to-class": "cal-opacity-100 cal-translate-x-0",
          "leave-active-class": "cal-duration-100 cal-ease-out",
          "leave-from-class": "cal-opacity-100",
          "leave-to-class": "cal-opacity-0 cal-translate-x-[1px]",
          mode: "out-in"
        }, {
          default: L(() => {
            var g, k, p, w, M, $, y, H, X, Y;
            return [
              e(i).timeSlots && e(i).timeSlots.length > 0 && !e(i).loading ? (n(), d("div", nc, [
                c("div", null, [
                  c("div", {
                    class: V([((k = (g = e(r).locale) == null ? void 0 : g.texts) != null && k.introduction || e(r).profileImage) && !e(f) && !e(r).compact ? "cal-pt-[54px]" : "cal-pt-0"])
                  }, [
                    c("p", sc, x(e(m)(e(i).timeSlots[0].start)), 1)
                  ], 2),
                  c("div", rc, [
                    e(r).locale && ((p = e(r).locale.texts) != null && p.choosePreferredTime) ? (n(), d("p", ic, x((w = e(r).locale.texts) == null ? void 0 : w.choosePreferredTime), 1)) : _("", !0)
                  ]),
                  c("div", {
                    class: V(["cal-mt-2 cal-overflow-y-auto cal-px-1", [(M = e(r).locale) != null && M.hideTimePreferences ? "cal-h-[375px]" : "cal-h-[345px]"]])
                  }, [
                    (n(!0), d(E, null, N(e(i).timeSlots, (R, F) => (n(), d("div", {
                      key: F,
                      class: "w-full"
                    }, [
                      v(Xl, {
                        "time-slot": R,
                        onSelectTimeSlot: (q) => h(R)
                      }, null, 8, ["time-slot", "onSelectTimeSlot"])
                    ]))), 128))
                  ], 2)
                ]),
                ($ = e(r).locale) != null && $.hideTimePreferences ? _("", !0) : (n(), d("div", dc, [
                  v(ac, { class: "cal-px-1" }),
                  v(cc, {
                    modelValue: u.value,
                    "onUpdate:modelValue": B[0] || (B[0] = (R) => u.value = R),
                    class: "cal-py-3"
                  }, {
                    before: L(() => [
                      O(" am/pm ")
                    ]),
                    after: L(() => [
                      O(" 24h ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              ])) : (n(), d("div", uc, [
                e(i).monthHasTimeSlots ? (n(), d("div", vc, [
                  c("div", xc, [
                    c("div", bc, [
                      gc,
                      e(r).locale && ((X = e(r).locale.texts) != null && X.chooseDate) ? (n(), d("p", {
                        key: 0,
                        class: "cal-mt-2 cal-w-40 cal-text-center cal-text-theme-900 dark:cal-text-theme-200",
                        innerHTML: (Y = e(r).locale.texts) == null ? void 0 : Y.chooseDate
                      }, null, 8, _c)) : _("", !0)
                    ])
                  ])
                ])) : (n(), d("div", mc, [
                  c("div", pc, [
                    c("div", hc, [
                      e(r).locale && ((y = e(r).locale.texts) != null && y.noTimeSlotAvailable) ? (n(), d("p", {
                        key: 0,
                        class: "dark:cal-text-theme-theme cal-text-center",
                        innerHTML: (H = e(r).locale.texts) == null ? void 0 : H.noTimeSlotAvailable
                      }, null, 8, fc)) : _("", !0)
                    ])
                  ])
                ]))
              ]))
            ];
          }),
          _: 1
        })
      ]))
    ], 2));
  }
}), kc = { class: "cal-grid cal-grid-cols-7 cal-gap-y-1" }, yc = /* @__PURE__ */ S({
  __name: "DaysGridLoadingSkeleton",
  setup(s) {
    function a(i, r) {
      return Math.floor(Math.random() * (r - i + 1) + i);
    }
    const o = a(1, 10), l = a(1, 10), t = 35 - o - l;
    return (i, r) => (n(), d("div", kc, [
      (n(!0), d(E, null, N(e(o), (m) => (n(), d("div", {
        key: m,
        class: "cal-mt-2 cal-h-10 cal-w-10 cal-rounded-md cal-bg-theme-100 dark:cal-bg-theme-800"
      }))), 128)),
      (n(), d(E, null, N(t, (m) => c("div", {
        key: m,
        class: "cal-mt-2 cal-h-10 cal-w-10 cal-animate-pulse cal-rounded-md cal-bg-theme-200 dark:cal-bg-theme-700"
      })), 64)),
      (n(!0), d(E, null, N(e(l), (m) => (n(), d("div", {
        key: m,
        class: "cal-mt-2 cal-h-10 cal-w-10 cal-rounded-md cal-bg-theme-100 dark:cal-bg-theme-800"
      }))), 128))
    ]));
  }
}), wc = {
  key: 0,
  class: "cal-grid cal-grid-cols-7 cal-gap-y-1"
}, Cc = { class: "cal-flex cal-items-center cal-justify-center" }, $c = ["disabled", "onClick"], Vc = { key: 1 }, at = /* @__PURE__ */ S({
  __name: "DaysGrid",
  setup(s) {
    const { setCalendarView: a } = Ce(b("calendarId")), { dayHasTimeSlot: o, isSelectedDay: l, dayClicked: t, state: i } = K(b("calendarId")), r = (m) => {
      t(m), a("pickingTime");
    };
    return (m, f) => (n(), d("div", null, [
      e(i).loading ? (n(), d("div", Vc, [
        v(yc)
      ])) : (n(), d("div", wc, [
        (n(!0), d(E, null, N(e(i).days, (u, h) => (n(), d("div", {
          key: h,
          class: "cal-mt-2 cal-flex cal-justify-center"
        }, [
          c("div", Cc, [
            c("button", {
              disabled: !e(o)(u) || u.isPast && !u.isCurrentMonth,
              class: V([{
                "cal-bg-theme-100 cal-font-medium  cal-text-theme-700 cal-ring-theme-200 focus:cal-outline-none focus:cal-ring-2 dark:cal-bg-theme-800 dark:cal-text-theme-100 dark:hover:cal-text-theme-300": e(o)(u) && !u.isPast && !e(l)(u),
                "cal-cursor-default cal-text-theme-500 dark:cal-text-theme-300": u.isPast && !u.isCurrentMonth || !e(o)(u) && u.isCurrentMonth,
                "cal-bg-accent-base cal-font-semibold cal-text-white  dark:cal-bg-accent-base dark:cal-text-white": e(l)(u),
                "cal-transition-color cal-bg-theme-100 cal-text-theme-700 cal-duration-100 hover:cal-bg-theme-200 hover:cal-text-accent-base hover:dark:cal-bg-theme-700 hover:dark:cal-text-accent-base": !e(l)(u) && e(o)(u) && !u.isPast,
                "cal-pointer-events-none cal-text-theme-500 dark:cal-text-theme-300": u.isPast
              }, "cal-h-10 cal-w-10 cal-rounded-md cal-text-sm"]),
              onClick: Q((C) => r(u), ["prevent"])
            }, x(u.label), 11, $c)
          ])
        ]))), 128))
      ]))
    ]));
  }
}), Sc = /* @__PURE__ */ c("div", { class: "cal-flex cal-justify-center" }, [
  /* @__PURE__ */ c("svg", {
    class: "cal-h-16 cal-w-16 cal-text-accent-base",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ c("path", {
      "fill-rule": "evenodd",
      d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
      "clip-rule": "evenodd"
    })
  ])
], -1), Ic = { class: "cal-mt-[24px] cal-text-center cal-font-semibold cal-text-theme-500 dark:cal-text-theme-100" }, Mc = { class: "cal-mt-2 cal-text-center cal-text-2xl cal-font-semibold cal-leading-[36px] cal-text-theme-700 dark:cal-text-theme-300" }, Tc = /* @__PURE__ */ S({
  __name: "SuccessMessage",
  setup(s) {
    const { config: a } = z(b("calendarId")), { selectedTimeSlot: o } = ge(b("calendarId")), { getFormattedTime: l, getFormattedDayInMonth: t } = le();
    return (i, r) => e(o) ? (n(), d("div", {
      key: 0,
      class: V(["cal-h-full cal-justify-center cal-rounded-xl cal-bg-white cal-px-0 cal-pb-20 cal-pt-24 dark:cal-bg-theme-900 sm:cal-px-6", [e(a).compact ? "cal-w-[330px] sm:cal-w-[400px]" : "cal-w-[330px] sm:cal-w-[840px]"]])
    }, [
      Sc,
      c("h2", Ic, x(e(t)(e(o).start)), 1),
      c("h3", Mc, x(e(l)(e(o).start)) + " - " + x(e(l)(e(o).end)), 1)
    ], 2)) : _("", !0);
  }
}), lt = T(!0);
function ut() {
  function s(a) {
    lt.value = a;
  }
  return {
    setIsSubscribed: s,
    isSubscribed: lt
  };
}
const Fc = {
  width: "69",
  height: "16",
  viewBox: "0 0 138 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bc = { "clip-path": "url(#clip0_804_3990)" }, Lc = ["fill"], Hc = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M24.1294 0.688468C22.3243 0.275387 19.357 0 16.0055 0C12.654 0 9.68399 0.275387 7.88158 0.688468C6.11528 1.06112 4.49523 1.93875 3.21829 3.21472C1.94134 4.49069 1.06247 6.11006 0.688468 7.87608C0.275387 9.68124 0 12.6485 0 16C0 19.3515 0.275387 22.3215 0.688468 24.1239C1.06207 25.8892 1.94012 27.5081 3.21602 28.784C4.49192 30.0599 6.11078 30.9379 7.87607 31.3115C9.68124 31.7246 12.6485 32 16 32C19.3515 32 22.3215 31.7246 24.1239 31.3115C25.8892 30.9379 27.5081 30.0599 28.784 28.784C30.0599 27.5081 30.9379 25.8892 31.3115 24.1239C31.7246 22.3188 32 19.3515 32 16C32 12.6485 31.7246 9.67848 31.3115 7.87608C30.9383 6.11151 30.0611 4.49315 28.7862 3.21733C27.5114 1.9415 25.8937 1.06303 24.1294 0.688468Z",
  fill: "url(#paint0_linear_804_3990)"
}, null, -1), zc = /* @__PURE__ */ c("path", {
  d: "M7.43098 27.2954C6.78152 27.2954 6.13068 27.0469 5.635 26.5512C4.64364 25.5598 4.64364 23.9506 5.635 22.9592L22.76 5.83422C23.7514 4.84286 25.3606 4.84286 26.352 5.83422C27.3433 6.82558 27.3433 8.43483 26.352 9.42619L9.22697 26.5512C8.73129 27.0469 8.08045 27.2954 7.43098 27.2954ZM20.0024 27.2954C19.3529 27.2954 18.7021 27.0469 18.2064 26.5512C17.2151 25.5585 17.2151 23.9506 18.2064 22.9592L22.7719 18.3938C23.7633 17.4024 25.3725 17.401 26.3639 18.3938C27.3552 19.3865 27.3552 20.9944 26.3639 21.9857L21.7984 26.5512C21.3027 27.0469 20.6519 27.2954 20.0024 27.2954ZM5.635 14.4571C6.13068 14.9528 6.78152 15.2013 7.43098 15.2013C8.08045 15.2013 8.73129 14.9528 9.22697 14.4571L14.2579 9.42619C15.2493 8.43483 15.2493 6.82558 14.2579 5.83422C13.2666 4.84286 11.6573 4.84286 10.666 5.83422L5.635 10.8652C4.64364 11.8565 4.64364 13.4658 5.635 14.4571Z",
  fill: "white"
}, null, -1), jc = /* @__PURE__ */ St('<defs><linearGradient id="paint0_linear_804_3990" x1="3.47509" y1="3.20074" x2="27.8922" y2="29.5382" gradientUnits="userSpaceOnUse"><stop stop-color="#FF8D47"></stop><stop offset="0.147634" stop-color="#FF7447"></stop><stop offset="0.454086" stop-color="#FF4247"></stop><stop offset="0.636926" stop-color="#E92A5B"></stop><stop offset="0.740367" stop-color="#DD1C67"></stop><stop offset="0.842991" stop-color="#D31071"></stop><stop offset="1" stop-color="#CF0283"></stop></linearGradient><clipPath id="clip0_804_3990"><rect width="137.143" height="32" fill="white"></rect></clipPath></defs>', 1), Dc = /* @__PURE__ */ S({
  __name: "ZapLogo",
  setup(s) {
    const { config: a } = z();
    return (o, l) => {
      var t;
      return n(), d("svg", Fc, [
        c("g", Bc, [
          c("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M98.0827 7.1006V3.06711H94.0231V7.1006H98.0827ZM97.9726 9.07742H94.1304V22.9083H97.9726V9.07742ZM88.6694 4.98751V9.07744H92.3711V12.2602H88.6694V17.7212C88.6694 19.0662 89.3824 19.6981 90.6173 19.6981H92.3711V22.9083H90.0955C86.9128 22.9083 84.8548 21.0981 84.8548 17.8864V12.2602H82.1924V9.07744H83.8939C84.4707 9.07744 84.8575 8.80212 84.8575 8.11381V4.98751H88.6694ZM65.6647 14.0168V22.9083H61.8832V20.988C61.4165 22.2778 59.8829 23.1272 57.986 23.1272C55.2974 23.1272 53.4583 21.3376 53.4583 18.9836C53.4583 16.2661 55.4888 14.6197 58.5077 14.6197H60.8466C61.5349 14.6197 61.8887 14.1806 61.8887 13.6038C61.8887 12.4515 60.9828 11.6559 59.419 11.6559C57.7451 11.6559 56.8943 12.698 56.8392 13.8502H53.4307C53.5959 11.0791 55.8453 8.85581 59.6324 8.85581C63.118 8.85719 65.6647 10.8877 65.6647 14.0168ZM61.8776 17.2284V17.0357H59.0845C57.9309 17.0357 57.1077 17.7488 57.1077 18.8253C57.1077 19.7311 57.8759 20.3616 58.9468 20.3616C60.8135 20.3561 61.8832 18.985 61.8832 17.2284H61.8776ZM40.335 19.6981L47.5801 12.2643H40.8058V9.07744H51.9481V12.2602L44.7897 19.6939H52.3611V22.9042H40.335V19.6981ZM71.3791 9.07744H67.5645V28.5057H71.3763V21.6721C72.1169 22.6055 73.4619 23.1272 75.0257 23.1272C79.0083 23.1272 81.6982 20.3079 81.6982 15.9991C81.6982 11.6903 79.2285 8.86269 75.3589 8.86269C73.5817 8.86269 72.205 9.52209 71.3791 10.5917V9.07744ZM74.5618 12.1239C76.562 12.1239 77.9387 13.6533 77.9387 15.9936C77.9387 18.298 76.5662 19.8357 74.5618 19.8357C72.5038 19.8357 71.1588 18.298 71.1588 15.9936C71.1588 13.6602 72.4969 12.1239 74.5618 12.1239ZM100.368 9.07743H104.21V11.0253C104.951 9.76299 106.275 8.85717 108.135 8.85717C110.303 8.85717 111.702 9.73546 112.361 11.3819C113.019 10.0369 114.748 8.85717 116.971 8.85717C119.99 8.85717 121.939 11.0804 121.939 13.8515V22.9083H118.123V15.0616C118.123 13.272 117.16 12.0977 115.681 12.0977C114.09 12.0977 113.074 13.2775 113.074 15.0616V22.9083H109.232V15.0616C109.232 13.272 108.299 12.0977 106.817 12.0977C105.226 12.0977 104.21 13.2775 104.21 15.0616V22.9083H100.368V9.07743ZM130.556 23.1286C133.959 23.1286 136.592 21.2068 137.143 18.2154L133.411 18.2113C133.108 19.3979 132.093 20.0009 130.556 20.0009C128.64 20.0009 127.401 18.7936 127.125 16.8457H137.06C137.088 16.5401 137.115 16.1285 137.115 15.6067C137.115 12.457 135.167 8.8613 130.282 8.8613C125.589 8.8613 123.448 12.457 123.448 15.9702C123.448 19.4502 125.863 23.1286 130.556 23.1286ZM133.301 14.4283H127.18C127.511 12.508 128.553 11.6572 130.282 11.6572C132.121 11.6572 133.191 12.892 133.301 14.4283Z",
            fill: ((t = e(a).theme) == null ? void 0 : t.mode) === "dark" ? "#ffffff" : "#090F23"
          }, null, 8, Lc),
          Hc,
          zc
        ]),
        jc
      ]);
    };
  }
}), Ac = {
  key: 0,
  class: "cal-flex cal-w-full cal-items-center cal-justify-center cal-gap-1 cal-pb-6 cal-text-xs cal-font-medium cal-tracking-tight cal-text-theme-800 dark:cal-text-theme-100"
}, Pc = ["href"], ct = /* @__PURE__ */ S({
  __name: "PoweredByZaptime",
  setup(s) {
    const { isSubscribed: a } = ut(), { config: o } = z(), l = D(() => {
      var i;
      return ((i = o.value.locale) == null ? void 0 : i.preset) === "cs" ? "https://zaptime.cz" : "https://zaptime.app";
    }), t = D(() => {
      var i;
      return ((i = o.value.locale) == null ? void 0 : i.preset) === "cs" ? "Vytvořeno službou" : "Powered by";
    });
    return (i, r) => e(a) ? _("", !0) : (n(), d("div", Ac, [
      c("a", {
        href: l.value,
        target: "_blank",
        class: "cal-flex cal-items-center cal-gap-1"
      }, [
        O(x(t.value) + " ", 1),
        v(Dc)
      ], 8, Pc)
    ]));
  }
}), Ec = { class: "cal-h-full cal-min-h-[360px]" }, Uc = {
  key: 0,
  class: "cal-h-full"
}, Nc = { class: "cal-mb-3 cal-mt-1 cal-grid cal-grid-cols-7" }, qc = { class: "cal-mb-5" }, Zc = { class: "cal-mb-3 cal-mt-1 cal-grid cal-grid-cols-7" }, Rc = { class: "cal-mb-8 cal-w-full" }, Oc = /* @__PURE__ */ S({
  __name: "Calendar",
  props: {
    bgClass: {
      type: String,
      default: null
    },
    classes: {
      type: String,
      default: ""
    },
    value: {
      type: Date
    }
  },
  emits: ["booking-confirmed"],
  setup(s, { emit: a }) {
    const o = a, { view: l, calendarView: t, setView: i } = Ce(b("calendarId")), { config: r } = z(b("calendarId")), m = b("color"), f = b("color2");
    function u(h) {
      i("success"), o("booking-confirmed", h);
    }
    return (h, C) => (n(), d("div", Ec, [
      e(l) === "calendar" ? (n(), d("div", Uc, [
        e(r).compact === !0 ? (n(), d("div", {
          key: 0,
          class: V(["cal-h-full cal-w-[330px] cal-bg-white dark:cal-bg-theme-900 sm:cal-w-[400px]", [e(r).compact ? "cal-rounded-xl" : ""]])
        }, [
          e(r).compact === void 0 || e(t) === "pickingDate" ? (n(), d("div", {
            key: e(t),
            class: V(["cal-h-full cal-w-full cal-rounded-l-xl cal-bg-theme-50 cal-px-3 cal-pb-1 dark:cal-bg-theme-900 sm:cal-px-[48px]", [e(r).compact ? "cal-rounded-r-xl" : ""]]),
            style: se({ backgroundColor: e(m) })
          }, [
            v(Ke),
            c("div", Nc, [
              v(et)
            ]),
            c("div", qc, [
              v(at)
            ])
          ], 6)) : _("", !0),
          e(r).compact === void 0 || e(t) === "pickingTime" ? (n(), d("div", {
            key: 1,
            class: V(["cal-h-full cal-rounded-r-xl cal-bg-white", [e(r).compact ? "cal-rounded-l-xl" : ""]]),
            style: se({ backgroundColor: e(f) })
          }, [
            v(tt)
          ], 6)) : _("", !0),
          v(ct)
        ], 2)) : (n(), d("div", {
          key: 1,
          class: V(["cal-flex cal-h-full cal-w-[841px] cal-rounded-l-xl cal-bg-white dark:cal-bg-theme-900", ["cal-rounded-xl", s.classes]])
        }, [
          (n(), d("div", {
            key: e(t),
            class: "cal-w-[330px] cal-rounded-l-xl cal-px-[48px] sm:cal-w-[400px]",
            style: se({ backgroundColor: e(m) })
          }, [
            v(Ke),
            c("div", Zc, [
              v(et)
            ]),
            c("div", Rc, [
              v(at)
            ]),
            v(ct)
          ], 4)),
          c("div", {
            class: "cal-rounded-r-xl cal-border-l cal-border-theme-200 dark:cal-border-theme-700",
            style: se({ backgroundColor: e(f) })
          }, [
            v(tt)
          ], 4)
        ], 2))
      ])) : _("", !0),
      v(we, {
        name: "slide-fade",
        mode: "out-in"
      }, {
        default: L(() => [
          e(l) === "form" ? (n(), J(kl, {
            key: 0,
            class: V([s.classes]),
            onGoBack: C[0] || (C[0] = () => e(i)("calendar")),
            onBookingConfirmed: u
          }, null, 8, ["class"])) : _("", !0)
        ]),
        _: 1
      }),
      e(l) === "success" ? (n(), J(Tc, {
        key: 1,
        class: V([s.classes])
      }, null, 8, ["class"])) : _("", !0)
    ]));
  }
});
function Gc(s) {
  const { config: a } = z(s), o = a.value.compact === !0, t = rt({
    large: 860
  }).smaller("large");
  t.value === !0 && (a.value.compact = !0), ae(t, (i) => {
    i === !0 ? a.value.compact = !0 : a.value.compact = o;
  });
}
function Wc(s, a, o) {
  function l(r) {
    return r.toString(16);
  }
  function t(r) {
    return parseInt(r, 16);
  }
  o = typeof o < "u" ? o : 50;
  let i = "#";
  for (let r = 0; r <= 5; r += 2) {
    let m = t(s.substr(r, 2)), f = t(a.substr(r, 2)), u = l(Math.floor(f + (m - f) * (o / 100)));
    for (; u.length < 2; )
      u = "0" + u;
    i += u;
  }
  return i;
}
function Jc(s) {
  const { config: a } = z(s), o = D(() => t(0.34)), l = D(() => t(0.24)), t = (i) => a.value && a.value.theme && a.value.theme.mode === "dark" && a.value.theme.colors && a.value.theme.colors[900] ? Wc(a.value.theme.colors[900].replace("#", ""), "000000", i * 100) : "";
  return {
    color: o,
    color2: l
  };
}
function mt(s, a) {
  const l = rt({
    large: 860
  }).smaller("large"), t = _t({ ...s }, { ...a });
  return l.value && (t.compact = !0), t;
}
function Xc(s, a) {
  const o = T(!1), l = T(!1), { setConfig: t } = z(a), { setLocations: i } = _e(a), { loadDateFnsConfig: r } = le(), { setStripeConfig: m } = fe(a), { setBookingForm: f } = Z(a), { setSelectedReservation: u } = ve(a), { init: h, dayClicked: C, state: I } = K(a), { setIsSubscribed: B } = ut();
  async function g() {
    var k;
    if (s === void 0 || s.token === void 0)
      console.error(
        "Zaptime error: Token is required, please enter your acquired token into the configuration. See more in the documentation: https://docs.zaptime.app/guide/vue-installation.html. If you don't have a token, you can acquire one at https://zaptime.app."
      );
    else {
      const p = await kt(s.token, s.apiBaseUrl, s.reservationUuid);
      if (p.ok) {
        if (p.val.disabled) {
          o.value = !1, l.value = !0;
          return;
        }
        await r(((k = p.val.configuration.locale) == null ? void 0 : k.preset) || "en"), p.val.reservation !== void 0 && u(p.val.reservation), p.val.locations && i(p.val.locations), p.val.stripeConfig && m(p.val.stripeConfig), p.val.customFields && f(p.val.customFields), p.val.isSubscribed === !1 && B(!1), o.value = !0;
        const w = mt(p.val.configuration, s);
        let M;
        p.val.analytics && (M = Qt(p.val.analytics));
        const $ = Ve(M);
        if ($ == null || $.track("zaptime:calendar_opened"), t(w), p.val.reservation !== void 0) {
          const y = I.days.find((H) => {
            if (H.date !== void 0)
              return qt(H.date, new Date(p.val.reservation.start));
          });
          y !== void 0 && It(() => {
            setTimeout(() => {
              C(y);
            }, 20);
          });
        }
      } else
        console.error(p.err), console.error(p.stack);
    }
  }
  return {
    isEnabled: o,
    initLoaded: l,
    init: g
  };
}
const Yc = {}, Qc = { class: "cal-flex cal-h-[400px] cal-w-full cal-max-w-[840px] cal-items-center cal-justify-center cal-bg-white" }, Kc = /* @__PURE__ */ c("p", { class: "cal-text-xl cal-font-bold cal-text-gray-700" }, "Event Type disabled!", -1), eo = [
  Kc
];
function to(s, a) {
  return n(), d("div", Qc, eo);
}
const ao = /* @__PURE__ */ $e(Yc, [["render", to]]), lo = {
  id: "zaptime-calendar",
  class: "cal-antialiased"
}, co = {
  key: 1,
  class: "cal-flex cal-min-h-[360px] cal-w-[820px] cal-items-center cal-justify-center"
}, oo = /* @__PURE__ */ c("svg", {
  class: "-cal-ml-1 cal-mr-3 cal-h-10 cal-w-10 cal-animate-spin cal-text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ c("circle", {
    class: "cal-opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /* @__PURE__ */ c("path", {
    class: "cal-opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1), no = [
  oo
], so = { key: 2 }, xo = /* @__PURE__ */ S({
  __name: "App",
  props: {
    config: { default: void 0 },
    calendarId: { default: void 0 }
  },
  emits: ["booking-confirmed", "time-slot-changed", "calendar-loaded"],
  setup(s, { emit: a }) {
    Mt((g) => {
      var k, p, w, M, $, y, H, X, Y, R, F, q, G, ce, oe, ne, j, A, P, Se, Ie, Me, Te, Fe, Be, Le, He, ze, je, De, Ae, Pe, Ee, Ue, Ne, qe, Ze, Re, Oe, Ge, We, Je;
      return {
        "6ff8734a": ((w = (p = (k = e(u)) == null ? void 0 : k.theme) == null ? void 0 : p.colors) == null ? void 0 : w["25"]) || "#f8fafc",
        "52280b03": ((y = ($ = (M = e(u)) == null ? void 0 : M.theme) == null ? void 0 : $.colors) == null ? void 0 : y["50"]) || "#f8fafc",
        "119c1164": ((Y = (X = (H = e(u)) == null ? void 0 : H.theme) == null ? void 0 : X.colors) == null ? void 0 : Y["100"]) || "#f1f5f9",
        ba205534: ((q = (F = (R = e(u)) == null ? void 0 : R.theme) == null ? void 0 : F.colors) == null ? void 0 : q["200"]) || "#e2e8f0",
        "4f8e6693": ((oe = (ce = (G = e(u)) == null ? void 0 : G.theme) == null ? void 0 : ce.colors) == null ? void 0 : oe["300"]) || "#cbd5e1",
        "76adb8a9": ((A = (j = (ne = e(u)) == null ? void 0 : ne.theme) == null ? void 0 : j.colors) == null ? void 0 : A["400"]) || "#64748b",
        "531431f2": ((Ie = (Se = (P = e(u)) == null ? void 0 : P.theme) == null ? void 0 : Se.colors) == null ? void 0 : Ie["500"]) || "#475569",
        "5f3e3e2f": ((Fe = (Te = (Me = e(u)) == null ? void 0 : Me.theme) == null ? void 0 : Te.colors) == null ? void 0 : Fe["600"]) || "#334155",
        "2c58cf2d": ((He = (Le = (Be = e(u)) == null ? void 0 : Be.theme) == null ? void 0 : Le.colors) == null ? void 0 : He["700"]) || "#384250",
        58616640: ((De = (je = (ze = e(u)) == null ? void 0 : ze.theme) == null ? void 0 : je.colors) == null ? void 0 : De["800"]) || "#1e293b",
        "0c56333b": ((Ee = (Pe = (Ae = e(u)) == null ? void 0 : Ae.theme) == null ? void 0 : Pe.colors) == null ? void 0 : Ee["900"]) || "#020617",
        "74eec306": ((qe = (Ne = (Ue = e(u)) == null ? void 0 : Ue.theme) == null ? void 0 : Ne.colors) == null ? void 0 : qe.accentLight) || "#2ED3B7",
        "7231eb36": ((Oe = (Re = (Ze = e(u)) == null ? void 0 : Ze.theme) == null ? void 0 : Re.colors) == null ? void 0 : Oe.accentBase) || "#15B79E",
        "2a78caea": ((Je = (We = (Ge = e(u)) == null ? void 0 : Ge.theme) == null ? void 0 : We.colors) == null ? void 0 : Je.accentDark) || "#0E9384",
        d24c65a2: B.value
      };
    });
    const o = T(!1), l = s, t = a;
    xe("calendarId", l.calendarId);
    const { init: i, initLoaded: r, isEnabled: m } = Xc(l.config, l.calendarId), { setConfig: f, config: u } = z(l.calendarId), { selectedTimeSlot: h } = ge(l.calendarId), { color: C, color2: I } = Jc(l.calendarId);
    xe("color", C), xe("color2", I), Gc(l.calendarId), ae(h, (g) => {
      t("time-slot-changed", g);
    }), ae(
      () => l.config,
      (g) => {
        f(mt(u.value, g));
      }
    );
    const B = D(() => {
      var g, k;
      return ((g = u == null ? void 0 : u.value.theme) == null ? void 0 : g.borderRadius) !== "full" ? (k = u == null ? void 0 : u.value.theme) == null ? void 0 : k.borderRadius : "24px";
    });
    return ye(async () => {
      await i(), o.value = !0, t("calendar-loaded");
    }), (g, k) => {
      var p;
      return n(), d("div", lo, [
        c("div", {
          class: V(["", [((p = e(u).theme) == null ? void 0 : p.mode) === "light" ? "" : "cal-dark"]])
        }, [
          e(m) ? re((n(), J(Oc, {
            key: 0,
            classes: g.$attrs.class ? String(g.$attrs.class) : "",
            onBookingConfirmed: k[0] || (k[0] = (w) => t("booking-confirmed", w))
          }, null, 8, ["classes"])), [
            [st, o.value]
          ]) : _("", !0),
          o.value ? _("", !0) : (n(), d("div", co, no)),
          !e(m) && e(r) ? (n(), d("div", so, [
            v(ao)
          ])) : _("", !0)
        ], 2)
      ]);
    };
  }
});
export {
  xo as ZapTimeCalendar,
  xo as ZaptimeCalendar,
  _o as book,
  ko as cancel,
  yo as confirm,
  wo as reserve,
  Ce as useCalendarViewState
};
